exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".list-group[_v-1ff01b77]{padding-left:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-1ff01b77&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/pages/Deliver-system.vue
// module id = 410
// module chunks = 0